import { StyledLink } from './styled';

export const Link = StyledLink;
